import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

const deviceId = (() => {
  let id = localStorage.getItem("pc-device-id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("pc-device-id", id);
  }
  return id;
})();
api.defaults.headers.common["X-Device-Id"] = deviceId;

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

const GENERIC = "Something went wrong. Please try again in a moment.";

export function formatError(e) {
  const res = e?.response;
  if (!res) return "We couldn't connect. Check your internet connection and try again.";
  if (res.status >= 500) return typeof res.data?.detail === "string" && res.status === 503 ? res.data.detail : GENERIC;
  if (res.status === 429 && typeof res.data?.detail !== "string") return "Too many attempts. Please wait a little and try again.";
  const detail = res.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Some details aren't valid. Please check what you entered and try again.";
  return detail?.message || GENERIC;
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const gbp = (n) => new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);
